<template>
  <div>
    <div align="left">
      <el-date-picker
        v-model="dateMonth"
        type="month"
        value-format="yyyy-MM"
        placeholder="选择月">
      </el-date-picker>
      <el-button type="primary" icon="el-icon-circle-plus" @click="search" >查询</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :summary-method="getSummaries"
      show-summary
      max-height="100%">
      <el-table-column
        fixed
        prop="date"
        label="日期"
        width="100">
      </el-table-column>
      <el-table-column
        prop="infectious_num"
        label="感染性数量"
        width="100">
      </el-table-column>
      <el-table-column
        prop="infectious_weight"
        label="感染性重量"
        width="150">
      </el-table-column>
      <el-table-column
        prop="injure_num"
        label="损伤性数量"
        width="180">
      </el-table-column>
      <el-table-column
        prop="injure_weight"
        label="损伤性重量"
        width="140">
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      search(){
        if (this.dateMonth==="" || this.dateMonth===undefined || this.dateMonth===null){
          this.$message.error('请选择时间');
          return
        }
        let that=this;
        window.ws.AddFunc("S2W_StatisticsByDayRes",function (code,list) {
          that.tableData=list
        });
        console.log("search:",this.dateMonth)
        window.ws.Call("W2S_StatisticsByDay",this.dateMonth);
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] =Math.round(sums[index]*100)/100
          } else {
            sums[index] = 0;
          }
        });
        return sums;
      }
    },
    mounted() {
      //console.dir(Math);
    },
    data() {
      return {
        dateMonth:'',
        tableData: []
        // tableData: [
        //   {date:"2021-06-01",infectious_num:"740",infectious_weight:"6570.61",injure_num:"173",injure_weight:"852.30"  },
        //   {date:"2021-06-02",infectious_num:"749",infectious_weight:"7091.14",injure_num:"171",injure_weight:"840.88"  },
        //   {date:"2021-06-03",infectious_num:"830",infectious_weight:"8123.34",injure_num:"194",injure_weight:"870.22"  },
        //   {date:"2021-06-04",infectious_num:"782",infectious_weight:"7668.66",injure_num:"187",injure_weight:"1080.21" },
        //   {date:"2021-06-05",infectious_num:"733",infectious_weight:"7582.09",injure_num:"166",injure_weight:"781.61"  },
        //   {date:"2021-06-06",infectious_num:"560",infectious_weight:"6140.74",injure_num:"155",injure_weight:"710.94"  },
        //   {date:"2021-06-07",infectious_num:"562",infectious_weight:"5433.02",injure_num:"168",injure_weight:"723.19"  },
        //   {date:"2021-06-08",infectious_num:"628",infectious_weight:"5788.13",injure_num:"157",injure_weight:"630.83"  },
        //   {date:"2021-06-09",infectious_num:"747",infectious_weight:"7759.81",injure_num:"166",injure_weight:"810.56"  },
        //   {date:"2021-06-10",infectious_num:"704",infectious_weight:"7284.84",injure_num:"171",injure_weight:"798.34"  },
        //   {date:"2021-06-11",infectious_num:"775",infectious_weight:"7879.90",injure_num:"171",injure_weight:"832.12"  },
        //   {date:"2021-06-12",infectious_num:"738",infectious_weight:"7373.84",injure_num:"158",injure_weight:"710.53"  },
        //   {date:"2021-06-13",infectious_num:"639",infectious_weight:"6619.18",injure_num:"140",injure_weight:"630.38"  },
        //   {date:"2021-06-14",infectious_num:"484",infectious_weight:"4717.19",injure_num:"117",injure_weight:"569.99"  },
        //   {date:"2021-06-15",infectious_num:"559",infectious_weight:"5636.31",injure_num:"149",injure_weight:"733.94"  },
        //   {date:"2021-06-16",infectious_num:"770",infectious_weight:"6715.20",injure_num:"165",injure_weight:"759.95"  },
        //   {date:"2021-06-17",infectious_num:"784",infectious_weight:"8144.31",injure_num:"182",injure_weight:"1084.72" },
        //   {date:"2021-06-18",infectious_num:"760",infectious_weight:"7212.10",injure_num:"193",injure_weight:"865.59"  },
        //   {date:"2021-06-19",infectious_num:"810",infectious_weight:"7839.52",injure_num:"180",injure_weight:"991.82"  },
        //   {date:"2021-06-20",infectious_num:"627",infectious_weight:"6417.54",injure_num:"155",injure_weight:"748.55"  },
        //   {date:"2021-06-21",infectious_num:"564",infectious_weight:"5328.65",injure_num:"172",injure_weight:"853.62"  },
        //   {date:"2021-06-22",infectious_num:"716",infectious_weight:"6148.72",injure_num:"167",injure_weight:"811.49"  },
        //   {date:"2021-06-23",infectious_num:"803",infectious_weight:"8076.75",injure_num:"173",injure_weight:"927.50"  },
        //   {date:"2021-06-24",infectious_num:"764",infectious_weight:"7219.96",injure_num:"178",injure_weight:"938.27"  },
        //   {date:"2021-06-25",infectious_num:"810",infectious_weight:"7715.96",injure_num:"183",injure_weight:"972.24"  },
        //   {date:"2021-06-26",infectious_num:"767",infectious_weight:"7366.48",injure_num:"156",injure_weight:"904.40"  },
        //   {date:"2021-06-27",infectious_num:"675",infectious_weight:"6703.63",injure_num:"159",injure_weight:"728.98"  },
        //   {date:"2021-06-28",infectious_num:"585",infectious_weight:"5161.94",injure_num:"149",injure_weight:"584.99"  },
        //   {date:"2021-06-29",infectious_num:"746",infectious_weight:"6902.18",injure_num:"177",injure_weight:"848.66"  },
        //   {date:"2021-06-30",infectious_num:"746",infectious_weight:"6902.43",injure_num:"148",injure_weight:"719.37"  },
        // ]
      }
    }
  }
</script>





































// WEBPACK FOOTER //
// src/view/StatisticsByDay.vue